// This file should be considered SoT for internal route paths
import { COSMOS_DOMAIN, DOMAIN } from 'shared/helpers/globals';

// Query Params
export const ADDRESS_UUID_PARAM = ':addressUUID';
export const ACCOUNT_URL = '/account';
export const LOGOUT_URL = `${DOMAIN}/logout`;
export const TERMS_OF_SERVICE_URL = `${DOMAIN}/terms`;
export const PRIVACY_POLICY_URL = `${DOMAIN}/privacy`;
export const FAQ_URL = 'https://help.opendoor.com/hc/en-us';
export const PRIVACY_CENTER_URL = 'https://opendoor-privacy.relyance.ai/';

/**
 * @deprecated - The legacy base routes for all of cake
 * @internal
 */
export const CUSTOMER_ADDRESS_BASE_ROUTE = `/dashboard/customer/`;
/**
 * @deprecated
 * @internal
 */
export const MONITOR_BASE_ROUTE = `/dashboard/monitor/`;
/** @deprecated */
export const ADDRESS_OVERVIEW_BASE_ROUTE = `/dashboard/overview`;

// The base routes for all of cake
export const ADDRESS_SELL_BASE_ROUTE = `/dashboard/sell`;
const ADDRESS_HOW_IT_WORKS_BASE_ROUTE = `/dashboard/how-it-works`;
export const ADDRESS_MORE_ROUTE = `/dashboard/more`;
/** @internal */
export const ADDRESS_CONTACT_BASE_ROUTE = `/dashboard/contact`;
const ADDRESS_BUY_SELL_PROGRESS_BASE_ROUTE = '/dashboard/buy-sell-progress';

export const BUY_ROUTE = '/dashboard/buy';
/** @internal */
export const BUYER_SHOWING_REQUEST_CREATION_ROUTE = `${BUY_ROUTE}/tour`;
const BUY_ONLY_SUB_PATHS = [
  `${BUY_ROUTE}/feed`,
  `${BUY_ROUTE}/search`,
  `${BUY_ROUTE}/my-offers`,
  `${BUY_ROUTE}/favorites`,
];

const HOW_IT_WORKS_SUB_PATHS = [
  `${ADDRESS_HOW_IT_WORKS_BASE_ROUTE}/sell`,
  `${ADDRESS_HOW_IT_WORKS_BASE_ROUTE}/sell-and-buy`,
];

const CONTACT_SUB_PATHS = [
  `${ADDRESS_CONTACT_BASE_ROUTE}/support`,
  `${ADDRESS_CONTACT_BASE_ROUTE}/title`,
  `${ADDRESS_CONTACT_BASE_ROUTE}/sell`,
  `${ADDRESS_CONTACT_BASE_ROUTE}/buy`,
];

/** @internal */
export const HUB_BASE_ROUTES = [
  ADDRESS_SELL_BASE_ROUTE,
  BUY_ROUTE,
  ...BUY_ONLY_SUB_PATHS,
  ...HOW_IT_WORKS_SUB_PATHS,
  ADDRESS_BUY_SELL_PROGRESS_BASE_ROUTE,
  ADDRESS_HOW_IT_WORKS_BASE_ROUTE,
  ADDRESS_MORE_ROUTE,
  ADDRESS_CONTACT_BASE_ROUTE,
  ...CONTACT_SUB_PATHS,
];

/** @internal */
export const HUB_ROUTES = [
  ADDRESS_SELL_BASE_ROUTE + `/${ADDRESS_UUID_PARAM}?`,
  BUY_ROUTE + `/${ADDRESS_UUID_PARAM}?`,
  ADDRESS_BUY_SELL_PROGRESS_BASE_ROUTE + `/${ADDRESS_UUID_PARAM}`,
  ADDRESS_HOW_IT_WORKS_BASE_ROUTE + `/${ADDRESS_UUID_PARAM}?`,
  ADDRESS_MORE_ROUTE + `/${ADDRESS_UUID_PARAM}?`,
  ADDRESS_CONTACT_BASE_ROUTE + `/${ADDRESS_UUID_PARAM}?`,
];

// All the following routes are ONLY used only for navigation purposes NOT route definition

/**
 * HUB ROUTES
 */

export const getHubMoreRoute = () => `${ADDRESS_MORE_ROUTE}/${ADDRESS_UUID_PARAM}?`;

/** Contact route*/
export const getHubContactRoute = () => `${ADDRESS_CONTACT_BASE_ROUTE}/${ADDRESS_UUID_PARAM}?`;
export const getHubContactSupportRoute = () => `${getHubContactRoute()}/support`;
export const getHubContactSellRoute = () => `${getHubContactRoute()}/sell`;
export const getHubContactsTitleRoute = () => `${getHubContactRoute()}/title`;

// Buying routes -- Route format which includes an optional addressUUID
export const getHubBuyingRoute = () => `${BUY_ROUTE}/${ADDRESS_UUID_PARAM}?`;

// Selling routes
/** Base selling route -- Route format which includes an optional addressUUID */
export const getHubSellingRoute = () => ADDRESS_SELL_BASE_ROUTE + `/${ADDRESS_UUID_PARAM}?`;
export const getSellDirectTimeoutRoute = () =>
  ADDRESS_SELL_BASE_ROUTE + `/${ADDRESS_UUID_PARAM}/timeout`;
/** Entrypoint to a multi-step referral form */
export const getAgentReferralFormRoute = () => `${getHubSellingRoute()}/agent-referral`;
/**
 * Route for SSVA targeting experiment. Asks user about the home occupancy and directs them to SSVA.
 */
export const getAssessmentNextStepRoute = () => `${getHubSellingRoute()}/next-step`;
export const getHubSSVAUploadRoute = () => `${getHubSellingRoute()}/virtual-assessment/upload`;
export const getHubSSVAUploadWholeHomeRoute = () =>
  `${getHubSellingRoute()}/virtual-assessment/upload/whole-home`;
export const getHubSSVAUploadSellerDisclosureDocumentRoute = () =>
  `${getHubSellingRoute()}/virtual-assessment/upload/seller-disclosure`;
export const getHubSSVAUploadInteriorRoute = () =>
  `${getHubSellingRoute()}/virtual-assessment/upload/interior`;
export const getHubSSVAUploadBackyardRoute = () =>
  `${getHubSellingRoute()}/virtual-assessment/upload/backyard`;
export const getHubSSVAUploadFrontyardRoute = () =>
  `${getHubSellingRoute()}/virtual-assessment/upload/frontyard`;
/** Page for requesting a late checkout */
export const getHubLateCheckoutWizardRoute = () => `${getHubSellingRoute()}/late-checkout`;
export const getHubHomeDetailsRoute = () => `${getHubSellingRoute()}/home-details`;
export const getCompleteFormsRoute = () => `${getHubSellingRoute()}/complete-forms`;
export const getScheduleFinalAssessmentRoute = () =>
  `${getHubSellingRoute()}/schedule-final-assessment`;
export const getExteriorAssessmentSelfSchedulingRoute = () =>
  getHubSellingRoute() + `/exterior-assessment/schedule`;

// How it works routes
export const getHowItWorksRedirectUrl = () => `${COSMOS_DOMAIN}/how-it-works-sell`;

/** Final offer: Shows a customer a screen where they must choose between cash offer and listing */
export const getChooseSellOptionRoute = () => `${getHubSellingRoute()}/choose-how-to-sell/options`;
